<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-66">
            <form ref="insect_add" @submit.prevent="addInterventionPlan">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'plus']"/>
                        </div>
                        <h4 class="title">Ajout d'un plan d'intervention</h4>
                    </md-card-header>
                    <intervention-group-form :interventionGroup="interventionGroup" :errors="errors"></intervention-group-form>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">
                            Enregistrer
                        </md-button>
                        <md-button class="md-warning"
                                   @click="goBack">
                            Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
import InterventionGroupForm from "@/pages/Contracts/InterventionPlan/components/InterventionGroupForm";
export default {
    name: "InterventionPlanAdd",
    components: {
        InterventionGroupForm
    },
    data() {
        return {
            interventionGroup: {
                types: [],
                months: [],
                duration: null
            },
            errors: []
        }
    },
    methods: {
        async addInterventionPlan() {
            this.errors = []
            let hours = parseInt(this.$moment(this.interventionGroup.duration).format('HH'))
            let minutes = parseInt(this.$moment(this.interventionGroup.duration).format('mm'))
            try {
                await this.$store.dispatch('interventionPlans/addInterventionPlan', {
                    contract_id: this.$route.params.contractId,
                    intervention_types: this.interventionGroup.types.map(type => type.id),
                    months: this.interventionGroup.months.map(month => month.value),
                    duration: ((hours * 60) + minutes)
                })
                await this.$store.dispatch('alerts/success', 'Plan d\'intervention ajouté')
                this.$router.back()
            } catch (e) {
                this.errors = e.response.data.errors
            }
        },
        goBack() {
            this.$router.back()
        }
    }
}
</script>

<style scoped>

</style>
